<template>
  <div class="chart">
    <h3>{{ data0.name }}</h3>
    <div id="myChart3" :auto-resize="true"></div>
    <div class="legend">
      <el-descriptions class="margin-top" :column="1" :colon="false">
        <el-descriptions-item label="技术成果" labelClassName="Achievement">
          {{
          data0.AchievementsRow
          }}
        </el-descriptions-item>
        <el-descriptions-item label="技术需求" labelClassName="DemandRow">
          {{
          data0.DemandRow
          }}
        </el-descriptions-item>
        <el-descriptions-item
          label="高层次人才"
          labelClassName="PersonnelRegRow"
        >{{ data0.PersonnelRegRow }}</el-descriptions-item>
      </el-descriptions>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      data0: {},
    }
  },
  created() {},
  mounted() {},
  methods: {
    startCharts(val) {
      //// console.log("data0", val);
      this.data0 = val
      this.drawLine(val)
    },
    drawLine(val) {
      // 基于准备好的dom，初始化echarts实例
      let myChart3 = this.$echarts.init(document.getElementById('myChart3'))
      //// console.log(val, "val");
      // 绘制图表
      myChart3.setOption({
        polar: {
          radius: [45, '30%'],
        },
        angleAxis: {
          max: val.AchievementsRow,
          startAngle: -90,
          show: false,
        },
        radiusAxis: {
          type: 'category',
          show: false,
          // data: ['a', 'b', 'c', 'd']
        },

        series: [
          {
            type: 'bar',
            data: [
              {
                value: val.AchievementsRow,
                itemStyle: { color: '#2769DC' },
                name: '技术成果',
              },
              {
                value: val.DemandRow,
                itemStyle: { color: '#50C5D2' },
                name: '技术需求',
              },
              {
                value: val.PersonnelRegRow,
                itemStyle: { color: '#FB8E3D' },
                name: '高层次人才',
              },
            ],

            coordinateSystem: 'polar',
          },
        ],
      })
      //// console.log(myChart3);
      window.onresize = function () {
        //// console.log("自适应");
        //自适应大小, 不用的话不会自适应大小。
        myChart3.resize()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.chart {
  /* width: 10.25rem; */
  height: 11.75rem;
  margin-bottom: 2.8125rem;
  margin-right: 2rem;
  /* margin: 2rem; */
  h3 {
    width: 9.25rem;
    font-size: 1.25rem;
    font-family: Microsoft YaHei;
    color: #333333;
  }
}
#myChart3 {
  /* padding-top: 1.875rem; */
  /* width: 11.25rem; */
  margin-left: 1.5625rem;
  width: 8rem;
  height: 11rem;
  margin-top: 6px;
}
.legend {
  width: 9.75rem;
  margin-top: 1.875rem;
  /deep/.el-descriptions-item__container {
    width: 8.5rem;
    margin-left: 2.625rem;
    margin-top: -0.625rem;
    position: relative;
    justify-content: space-between;
  }
  /deep/.el-descriptions-item__label {
    font-size: 0.875rem;
    color: #333333;
    font-family: MicrosoftYaHei;
  }
  /deep/.DemandRow::before {
    content: '';
    width: 0.5rem;
    height: 0.5rem;
    background: #50c5d2;
    position: absolute;
    left: -1.125rem;
    top: 0.375rem;
    border-radius: 50%;
    opacity: 1;
  }
  /deep/.Achievement::before {
    content: '';
    width: 0.5rem;
    height: 0.5rem;
    background: #2769dc;
    position: absolute;
    left: -1.125rem;
    top: 0.375rem;
    border-radius: 50%;
    opacity: 1;
  }
  /deep/.PersonnelRegRow::before {
    content: '';
    width: 0.5rem;
    height: 0.5rem;
    background: #fb8e3d;
    position: absolute;
    left: -1.125rem;
    top: 0.375rem;
    border-radius: 50%;
    opacity: 1;
  }
  /deep/.el-descriptions-item__content {
    font-size: 0.875rem;
    color: #333333;
    font-family: MicrosoftYaHei;
    font-weight: bold;
  }
}
</style>
